<template>
  <div
    :class="['geo-popup smooth-shadow', { pinned: pinned }]"
    :style="{
      transform: `translate(${x - 10}px, ${y + 10}px)`,
    }"
  >
    <div class="popup-header">
      <i class="material-icons popup-icon">{{ icon || "data_usage" }}</i>
      <div class="header-texts">
        <h4 class="name ellipsis">{{ title }}</h4>
        <p class="value ellipsis">{{ value }}</p>
      </div>
    </div>
    <simplebar
      v-if="metadata"
      class="body-wrapper"
      data-auto-hide="false"
      data-simplebar-auto-hide="false"
    >
      <div v-if="metadata" class="meta">
        <div class="meta-item" v-for="(item, index) in getMeta" :key="index">
          <p>{{ item.name }}</p>
          <p>{{ item.value }}</p>
        </div>
      </div>
    </simplebar>
  </div>
</template>

<script>
import { format } from "../../lib/numberFormatter";
export default {
  props: {
    icon: String, // icon for the popup
    title: String, // title of the popup
    value: [String, Number], // value of the popup
    metadata: Object, // metadata object
    pinned: Boolean, // whether the popup is pinned or not
    x: Number, // x position of mouse
    y: Number, // y position of the mouse
  },
  computed: {
    getMeta() {
      if (this.metadata) {
        return Object.keys(this.metadata).map((item) => {
          const val = Number(this.metadata[item]);
          const formattedValue = isNaN(val)
            ? this.metadata[item]
            : this.formatNumber(val);
          return {
            name: item,
            value: formattedValue,
          };
        });
      } else {
        return null;
      }
    },
  },
  methods: {
    formatNumber(num) {
      let value = parseFloat(num || 0);
      value = isNaN(value) ? 0 : value;
      value = format(value.toFixed(3), 3);
      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
.geo-popup {
  z-index: 999;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  width: 250px;
  background: var(--color-secondary-light);
  color: var(--font-color);
  border-radius: 5px;
  transition: 0.3s all ease-in-out;
  max-height: 300px;
  display: flex;
  flex-direction: column;
  /* overflow: hidden; // So that simplebar doesn't obstruct the map. */

  &.pinned::after {
    position: absolute;
    content: "";
    top: -20px;
    left: 0px;
    right: 0;
    width: 10px;
    height: 10px;
    background-color: var(--color-primary);
    border-radius: 50px;
    border: 2px solid var(--color-primary-light);
  }

  .popup-header {
    display: flex;
    flex-direction: row;
    background: var(--color-secondary);
    border-radius: 5px;
    align-items: center;
    padding: 10px;

    .popup-icon {
      padding: 10px;
      background: var(--color-secondary-light);
      border-radius: 50%;
    }

    .header-texts {
      display: flex;
      flex-direction: column;
      margin-left: 10px;

      .name {
        color: var(--color-primary);
      }

      .value {
        margin: 0;
        padding: 5px 0;
        color: var(--font-color);
        font-size: 1.2rem;
      }
    }
  }

  .body-wrapper {
    /* THIS WORKS: */
    flex: 1;
    min-height: 5px;

    .meta {
      display: flex;
      flex-direction: column;

      .meta-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 10px;

        p {
          margin: 0;
          padding: 0;
        }

        &:nth-child(odd) {
          background: var(--color-default-background);
        }

        &:last-child {
          border-radius: 0 0 5px 5px;
        }
      }
    }
  }
}
</style>
